module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_achievement04-f509613de0dc4ba6972debd6eb8a7c59.jpg";